import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import styles from "./business-card-body.module.scss";

import Row from "../../Row/Row";
import Social from "../../Social/Social";

const BusinessCardBody = (props) => {
    return (
        <div className={styles.business_card__body}>
            <h2 className={styles.title}>
                We are<span className={styles.bold}> AWESOME</span> at a lot of
                things!
            </h2>
            <Row
                type={"link"}
                rowContent={props.data.phone}
                rowHref={"tel:" + props.data.phone}
                rowName="Mobile"
            >
                <FontAwesomeIcon
                    icon={solid("phone")}
                    size="2x"
                    className={styles.row_icon}
                />
            </Row>
            <Row
                type={"link"}
                rowContent={props.data.email}
                rowHref={"mailto:" + props.data.email}
                rowName="Email"
            >
                <FontAwesomeIcon
                    icon={solid("envelope")}
                    size="2x"
                    className={styles.row_icon}
                />
            </Row>
            <Row
                type={"text"}
                rowContent={"Generation Marketing"}
                rowName={props.data.role}
            >
                <FontAwesomeIcon
                    icon={solid("briefcase")}
                    size="2x"
                    className={styles.row_icon}
                />
            </Row>
            <Row
                type={"link"}
                rowContent={"https://generationmarketing.ca"}
                rowHref="https://generationmarketing.ca"
                rowName="Website"
            >
                <FontAwesomeIcon
                    icon={solid("globe")}
                    size="2x"
                    className={styles.row_icon}
                />
            </Row>
            <Social linkedIn={props.data.linkedInLink} />
        </div>
    );
};

export default BusinessCardBody;
